import { action, observable, runInAction, makeObservable } from 'mobx';
import { request } from '@/framework/network/request'
import customHistory from '@/framework/customHistory'
import Company from '../model/Company'

export default class SwitchCompanyStore {
  loading: boolean;
  visible: boolean;
  companies: Company[];

  constructor () {
    makeObservable(this, {
      loading: observable,
      visible: observable,
      companies: observable,
      visibleCompanies: action,
      choose: action,
      cancel: action
    });

    this.loading = false
    this.visible = false
    this.companies = []
  }

  visibleCompanies = async () => {
    this.loading = true
    this.visible = true
    const res = await request.get(`/u/switch/current/company`)
    runInAction(() => {
      this.companies = res
      this.loading = false
    })
  };

  choose = async (id: number) => {
    this.loading = true
    await request.post(`/u/switch/current/company/${id}`, {})
    customHistory.push('/backend')
    window.location.reload()
  };

  cancel = () => {
    this.loading = false
    this.visible = false
  };
}
